<template>
  <div class="flex flex-col">
    <h3 class="capitalize-first text-base font-bold">
      {{ $t('global.button.dashboard.agenda.slots_duration') }}
    </h3>
    <div class="flex flex-row flex-wrap gap-2">
      <BaseButton
        v-for="predefined_slot_duration in predefined_slot_durations"
        :key="predefined_slot_duration.label"
        :title="predefined_slot_duration.label"
        size="extra-small"
        color="primary"
        :is-outline="
          predefined_slot_duration.slotDuration !== localSlotDuration
        "
        @click="localSlotDuration = predefined_slot_duration.slotDuration"
      />
    </div>
  </div>
</template>

<script>
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'

export default {
  name: 'SlotDurationSelector',
  components: { BaseButton },
  props: {
    slotDuration: {
      type: Object,
      required: true
    }
  },
  emits: ['update:slotTime', 'update:slot-duration'],
  data() {
    return {
      predefined_slot_durations: [
        {
          label: '15min',
          gate: true,
          slotDuration: '00:15:00'
        },
        {
          label: '30min',
          gate: true,
          slotDuration: '00:30:00'
        },
        {
          label: '1h',
          gate: true,
          slotDuration: '01:00:00'
        },
        {
          label: '2h',
          gate: true,
          slotDuration: '02:00:00'
        },
        {
          label: '4h',
          gate: true,
          slotDuration: '04:00:00'
        },
        {
          label: '6h',
          gate: true,
          slotDuration: '06:00:00'
        },
        {
          label: '24h',
          gate: true,
          slotDuration: '24:00:00'
        }
      ]
    }
  },
  computed: {
    localSlotDuration: {
      get() {
        return this.slotDuration
      },
      set(value) {
        this.$emit('update:slot-duration', value)
      }
    }
  },
  methods: {
    handlePredefinedSlotDuration(predefined_slot_duration) {
      this.localSlotDuration = predefined_slot_duration
    }
  }
}
</script>

<style scoped></style>
